import React, { createContext, useState } from "react";
import * as ls from "utils/localStorage";
import { LS_USER } from "constants/key";

export const AuthContext = createContext({
  isLoggedIn: false,
  userData: {
    userInfo: {
      userId: 0,
      username: "",
      email: "",
      vendorId: 0,
      firstName: "",
      lastName: "",
      role: "",
      requirePasswordChange: false,
    },
    token: "",
    expiration: 0,
    menuAccess: []
  },
});

const AuthProvider = ({ children }) => {
  const [userData, setUserData] = useState(ls.load(LS_USER));

  return (
    <AuthContext.Provider
      value={{
        userData,
        setUserData,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export default AuthProvider;
